import React from "react";

/**
 * Logo Pizzeria Salviano — immagine ufficiale fornita dal cliente.
 */
export const Logo = ({ className = "", height = 56 }) => (
  <img
    src="/images/logo.webp"
    alt="Pizzeria Salviano — Livorno"
    height={height}
    style={{ height, width: "auto" }}
    className={`block object-contain ${className}`}
    fetchPriority="high"
    decoding="async"
    loading="eager"
    data-testid="site-logo"
  />
);
